export default "__VITE_ASSET__a0aedb46__"